export class UserRole {
  static readonly API = "api";
  static readonly ADMIN = "super_admin";
  static readonly WAREHOUSE_MANAGER = "warehouse_manager";
  static readonly CLERK = "clerk";
  static readonly AGENT = "agent";
  static readonly SUPPORT = "support";
}

export enum Permissions {
  MANAGE_PRODUCTS = "manage_products",
}

export class OrganizationType {
  static readonly ADMIN = "relay";
  static readonly CARRIER = "carrier";
  static readonly UNLOADER = "unloader";
  static readonly POS = "pos";
}

export class TransactionType {
  static readonly CODE = "code";
  static readonly EXTERNAL = "external";
}

export class Features {
  static readonly ARRIVAL_TIME_CHECK_IN_TIME = "arrival_time_check_in_time";
  static readonly USE_USUAL_PRINTERS = "use_usual_printers";
  static readonly DEPARTMENTS = "departments";
  static readonly FHI = "number_six_digit";
  static readonly ENABLE_NOT_FIELD_FOR_CLERKS = "enable_note_field_for_clerks";
  static readonly ENABLE_LOCATION_ADMINISTRATIVE_FEE = "enable_location_administrative_fee";
  static readonly SHOW_COMPANY_FROM_SALE = "show_company_from_sale";
  static readonly SHOW_COMPLETED_SALES_TOTALS = "show_completed_sales_totals";
  static readonly ADD_CONVENIENCE_FEE_TEXT_TO_SALE = "add_convenience_fee_text_to_sale";
  static readonly APPLY_MAXIMUM_DOLLAR_AMOUNTS = "apply_maximum_dollar_amounts";
  static readonly ADD_COMPLETED_AT = "add_completed_at";
  static readonly PO_NUMBER_NOT_REQUIRED = "po_number_not_required";
  static readonly ENABLE_SEND_CHECKOUT_EMAIL = "enable_send_checkout_email";
  static readonly PROVIDE_LINE_ITEM_DETAILS_ON_CSV_REPORT = "provide_line_item_details_on_csv_report";
  static readonly REPLACE_COMPANY_WITH_CARRIER = "replace_company_with_carrier";
  static readonly TRANSACTION_DATA_EXPOSED = "transaction_data_exposed";
  static readonly ENABLE_PRODUCTS_PAGE = "enable_products_page";
}

export const phoneRegExp = /\+?[0-9]?([0-9]+)$/;
export const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const epnRegExp = /^(\d{6})$/;
